module.exports = __webpack_public_path__ + "static/media/logo_favicon_bmw.0a0216db.svg";